import { render } from "./LangSwitcher.vue?vue&type=template&id=03faa34a&scoped=true"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"

import "./LangSwitcher.vue?vue&type=style&index=0&id=03faa34a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03faa34a"]])

export default __exports__